// angular
// 	.module("HeroPRO")
// 	.controller("ChangePasswordController", changePasswordController);

import './changePassword.scss';

/* @ngInject */
export default function changePasswordController($scope, ChangePasswordFactory, CommonValidationFactory) {
    const vm = this;

    vm.originalPassword = '';
    vm.newPassword = '';
    vm.newConfirmPassword = '';
    vm.isEmailSent = false;
    vm.user = {};
    vm.passwordHint = '';

    init();

    /*= =======================================
	 =            Public Functions            =
	 ======================================== */

    vm.submitPasswordChange = function (isValid) {
        if (isValid && $scope.password.changePassword.$dirty) {
            const data = {
                curXWord: vm.originalPassword,
                newXWord: vm.newPassword,
            };
            submitPasswordChange(data);
        } else {
            vm.cancelChangePassword();
        }
    };

    vm.cancelChangePassword = function () {
        ChangePasswordFactory.isPasswordDirty = false;
        ChangePasswordFactory.changePasswordEnable = false;
    };

    vm.checkPassword = function () {
    //		console.log(vm.newPassword);
        vm.passwordHint = CommonValidationFactory.validatePassword(vm.newPassword);
        if (vm.passwordHint && vm.passwordHint.length > 0) {
            $scope.password.changePassword.txtNewPassword.$setValidity('invalid-password', false);
        } else {
            $scope.password.changePassword.txtNewPassword.$setValidity('invalid-password', true);
        }

        vm.checkConfirmPassword();
    };

    vm.checkConfirmPassword = function () {
        ChangePasswordFactory.isPasswordDirty = true;
        if (vm.newPassword !== vm.newConfirmPassword && (vm.newConfirmPassword !== '' && vm.newConfirmPassword !== undefined)) {
            $scope.password.changePassword.txtNewPassword.$setValidity('nomatch', false);
            $scope.password.changePassword.txtNewConfirmPassword.$setValidity('nomatch', false);
            vm.noMatchEerrorMessage = 'Passwords do not match';
            vm.isPasswordConfirmed = false;
        } else {
            $scope.password.changePassword.txtNewPassword.$setValidity('nomatch', true);
            $scope.password.changePassword.txtNewConfirmPassword.$setValidity('nomatch', true);
            vm.noMatchEerrorMessage = '';
            if (vm.newPassword === vm.newConfirmPassword) {
                vm.isPasswordConfirmed = true;
            }
        }

        if ($scope.password.changePassword.txtNewPassword.$invalid || $scope.password.changePassword.txtNewConfirmPassword.$invalid) {
            vm.isPasswordConfirmed = false;
        }
    };

    vm.requestPassword = function () {
        sendForgotPasswordEmail(vm.user.Email);
    };

    vm.clearOriginalPassword = function () {
        ChangePasswordFactory.isPasswordDirty = true;
        $scope.password.changePassword.txtOriginalPassword.$setValidity('incorrect', true);
        vm.errorMessage = '';
    };

    /* -----  End of Public Functions  ------*/

    /*= =======================================
	 =            Private Functions            =
	 ======================================== */

    function init() {
        vm.user = ChangePasswordFactory.userObj;
        resetPasswordFields();
    }

    function submitPasswordChange(data) {
        ChangePasswordFactory.changeUserPassword(data).then((response) => {
            if (response.data.ResultCode === 2) {
                $scope.password.changePassword.txtOriginalPassword.$setValidity('incorrect', false);
                vm.errorMessage = 'Password incorrect.';
                vm.isEmailConfirmed = false;
            } else if (response.data.ResultCode === 1) {
                resetPasswordFields();
                ChangePasswordFactory.changePasswordEnable = false;
                ChangePasswordFactory.statusMessage = 'Your password has been saved.';
            }
        });
    }

    function sendForgotPasswordEmail(email) {
        ChangePasswordFactory.requestRecoverPasswordEmail(email).then((response) => {
            if (response.data.Result || response.data.Data) {
                ChangePasswordFactory.statusMessage = `We've sent a reset password link to ${vm.user.Email}`;
            }
        });
    }

    function resetPasswordFields() {
        vm.originalPassword = '';
        vm.newPassword = '';
        vm.newConfirmPassword = '';
        vm.errorMessage = '';
    }

    /* -----  End of Private Functions  ------*/
}



// WEBPACK FOOTER //
// ./src/app/common/controls/changePassword/changePasswordController.js